import { ErrorHandler, NgModule } from '@angular/core';
import { APP_BASE_HREF } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, } from '@angular/common/http'; // HttpClientXsrfModule
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule, MatCheckboxModule, MatInputModule, MatOptionModule, MatRadioModule, MatSelectModule, } from '@angular/material';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import 'hammerjs';

import { environment } from '../environments/environment';
import { ConfigService } from './shared/service/config.service';
import { XsrfCorsInterceptor } from './shared/service/xsrf.cors.interceptor';
import { AppComponent, getTranslationPrefix } from './app.component';
import { GlobalErrorHandler } from './shared/handler/globalerrorhandler';
import { ControllerService } from './shared/service/controller.service';
import { PaymentService } from './shared/service/payment.service';
import { CreditCardValidatorDirective } from './shared/validator/creditcardvalidator.directive';
import { IbanValidatorDirective } from './shared/validator/ibanvalidator.directive';
import { Step1DonationComponent } from './step1-donation/step1-donation.component';
import { Step2NameComponent } from './step2-name/step2-name.component';
import { StepperComponent } from './shared/stepper/stepper.component';
import { Step3DropinComponent } from './step3-dropin/step3-dropin.component';
import { Step4DropinResultComponent } from './step4-dropin-result/step4-dropin-result.component';

const appRoutes: Routes = [
  {path: '', component: Step1DonationComponent},
  {path: 'step2', component: Step2NameComponent},
  {path: 'step3', component: Step3DropinComponent},
  {path: 'result', component: Step4DropinResultComponent},
];

@NgModule({
  declarations: [
    AppComponent,
    Step1DonationComponent,
    Step2NameComponent,
    Step3DropinComponent,
    Step4DropinResultComponent,
    CreditCardValidatorDirective,
    IbanValidatorDirective,
    StepperComponent,
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    BrowserModule,
    FormsModule,
    // HttpModule,
    HttpClientModule,
    // HttpClientXsrfModule.withOptions({cookieName: 'XSRF-TOKEN', headerName: 'X-XSRF-TOKEN'}),
    BrowserAnimationsModule,
    MatInputModule,
    MatRadioModule,
    MatButtonModule,
    MatOptionModule,
    MatSelectModule,
    MatCheckboxModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    ConfigService,
    ControllerService,
    PaymentService,
    {
      provide: APP_BASE_HREF,
      useValue: '/' + (window.location.pathname.split('/')[1] || 'doneer'),
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: XsrfCorsInterceptor,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}

export function HttpLoaderFactory(http: HttpClient) {
  if (environment.production) {
    return new TranslateHttpLoader(
      http,
      `/assets/donate/i18n/${getTranslationPrefix()}`,
      '.json'
    );
  } else {
    return new TranslateHttpLoader(
      http,
      `/assets/donate/i18n/${getTranslationPrefix()}`,
      '.json'
    );
  }
}
